import {
  Box,
  Button,
  Checkbox,
  Divider,
  Grid,
  Paper,
  Typography,
  Pagination,
} from "@mui/material";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import TicketComponent from "../../../../components/tickets/ticketComponent";
import InformationMale from "../../../../components/artsPersonComponent/informationMale";
import ConfusedMale from "../../../../components/artsPersonComponent/confusedMale";
import TicketComponentIxc from "../../../../components/tickets/ticketComponentIxc";

const FluxoAtendimentoIxc = ({
  theme,
  styles,
  selectEtapaFluxo,
  isSelecting,
  allSelected,
  partiallySelected,
  selectedItems,
  handleSelectAll,
  handleToggleSelectMode,
  handleOpen,
  handleSelectItem,
  refreshAtendimentos,
  getTicketDetails,
  allEtapasFluxoAtendimentos,
  setSnackbar,
  labelErp,
  isAtendimento,
  typeTitleModal,
  isOs = false,
}) => {
  const atendimentos = selectEtapaFluxo?.atendimentos || [];
  const erp = window?.config?.REACT_APP_ERP || process.env.REACT_APP_ERP || "";

  // 👇 Estado da paginação
  const [page, setPage] = useState(1);
  const itemsPerPage = 9; // quantidade de tickets por página

  // 👇 Calcular fatia de atendimentos
  const startIndex = (page - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentAtendimentos = atendimentos.slice(startIndex, endIndex);
  useEffect(() => {
    setPage(1);
  }, [atendimentos]);
  const totalPages = Math.ceil(atendimentos.length / itemsPerPage);

  return (
    <Paper
      elevation={theme.palette.mode === "dark" ? 0 : 3}
      sx={styles.paperFluxoTickets}
    >
      {atendimentos.length > 0 && erp === "HUBSOFT" && (
        <Box sx={styles.containerButton}>
          <Box sx={styles.boxActions}>
            <Box sx={styles.containerActions}>
              {isSelecting && (
                <>
                  <Checkbox
                    checked={allSelected}
                    indeterminate={partiallySelected}
                    onChange={handleSelectAll}
                  />
                  <Typography sx={{ fontWeight: "bold", fontSize: 12 }}>
                    Selecionar todos
                  </Typography>
                </>
              )}
            </Box>

            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {isSelecting && (
                <Button
                  disabled={!selectedItems.length}
                  size="small"
                  variant="contained"
                  onClick={handleOpen}
                >
                  Criar mensagem
                </Button>
              )}
              <Button
                size="small"
                variant={isSelecting ? "outlined" : "contained"}
                onClick={handleToggleSelectMode}
              >
                {isSelecting ? "Cancelar" : "Selecionar"}
              </Button>
            </Box>
          </Box>
          <Divider />
        </Box>
      )}

      <Grid
        container
        spacing={2}
        sx={{ padding: "0 20px 20px 20px", mt: 1 }}
        columns={{ xs: 4, sm: 4, md: 8, lg: 8, xl: 8, xxl: 12 }}
      >
        {atendimentos.length > 0 ? (
          currentAtendimentos.map((atendimento, key) => {
            const isSelected = selectedItems.some(
              (item) => item.id_atendimento === atendimento.id_atendimento,
            );

            return (
              <Grid item xs={4} sm={4} md={4} lg={4} key={key}>
                <Box
                  sx={{
                    ...styles.containerCheckBox,
                    border: isSelected
                      ? `2px solid ${theme.palette.primary.main}`
                      : "2px solid transparent",
                    position: "relative",
                  }}
                >
                  {isSelecting && (
                    <Checkbox
                      checked={isSelected}
                      onChange={() => handleSelectItem(atendimento)}
                      sx={styles.checkBox}
                    />
                  )}

                  <Box
                    sx={{
                      ...styles.checkOverlay,
                      backgroundColor: isSelected
                        ? theme.palette.primary.main
                        : "transparent",
                      opacity: isSelected ? 0.2 : 0,
                    }}
                  />

                  <TicketComponentIxc
                    protocolo={atendimento?.protocolo}
                    descricao={atendimento?.descricao_abertura}
                    assunto={atendimento?.assunto}
                    setor={atendimento?.setor}
                    filial={atendimento?.filial}
                    prioridade={atendimento?.prioridade}
                    sla={atendimento?.sla}
                    id_ticket={atendimento?.id_ticket}
                    cliente={atendimento?.cliente?.nome || ""}
                    historicoFluxoAtendimento={
                      atendimento?.historicoFluxoAtendimento
                    }
                    allEtapasFluxoAtendimentos={allEtapasFluxoAtendimentos}
                    refreshAtendimentos={refreshAtendimentos}
                    dataCadastro={dayjs(atendimento?.data_cadastro).format(
                      "DD/MM/YYYY",
                    )}
                    isEdit={true}
                    selectedCliente={atendimento?.isClienteAdd}
                    usuarioAbertura={atendimento?.usuario_abertura}
                    status={atendimento?.status}
                    ticketId={atendimento?.id_atendimento}
                    getTicketDetails={getTicketDetails}
                    setSnackbar={setSnackbar}
                    servicoId={atendimento?.idClienteServico || ""}
                    variantPaper="outlined"
                    labelErp={labelErp}
                    isAtendimento={isAtendimento}
                    typeTitleModal={typeTitleModal}
                    isOs={isOs}
                  />
                </Box>
              </Grid>
            );
          })
        ) : selectEtapaFluxo ? (
          <Box sx={{ width: "100%", marginTop: 4 }}>
            <ConfusedMale
              mainFill={theme.palette.secondary.dark}
              primaryCircleFill={theme.palette.secondary.main}
              highlightTitle={"Oops!"}
              subtitle={`Parece que não há tickets\nrelacionados a etapa:`}
              highlightSubtitle={selectEtapaFluxo?.etapaFluxoAtendimento}
            />
          </Box>
        ) : (
          <Box
            sx={{
              width: "100%",
              marginTop: 4,
            }}
          >
            <InformationMale
              mainFill={theme.palette.secondary.dark}
              primaryCircleFill={theme.palette.secondary.main}
              secondaryCircleFill={theme.palette.secondary.light}
              title={"Você ainda não selecionou nenhuma"}
              highlight={"etapa do fluxo"}
              subtitle={
                "Os tickets relacionados a essa etapa\naparecerão assim que ela for escolhida."
              }
            />
          </Box>
        )}
      </Grid>

      {/* 👇 PAGINAÇÃO */}
      {atendimentos.length > itemsPerPage && (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 2, mb: 2 }}>
          <Pagination
            count={totalPages}
            page={page}
            onChange={(e, value) => setPage(value)}
            color="primary"
          />
        </Box>
      )}
    </Paper>
  );
};

export default FluxoAtendimentoIxc;
